export default __webpack_public_path__ + "static/media/telegram.c56aed49.png";